import VehiclesError from './VehiclesError.js'

export class GenericVehiclesError extends VehiclesError {}
